export default __webpack_public_path__ + "c78f7a925d204acc2955a0e416b10dec.png";